import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React from 'react';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}
let DialogWithoutStaticHeader = ({ title, children, footer, onClose, maxWidth = 'sm', overflow = 'hidden', height = 'none', ...rest }) => {
    return (
        <>
            <Dialog onClose={onClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" open={true} maxWidth={maxWidth} {...rest}>
                {title && (
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {title}
                    </DialogTitle>
                )}
                <DialogContent style={{ overflow: overflow, height: height }}>{children}</DialogContent>
                {footer && <DialogActions>{footer}</DialogActions>}
            </Dialog>
        </>
    );
};

export default DialogWithoutStaticHeader;
